
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'activeMenuItems',
  pure: false
})
export class ActiveMenuItemsPipe implements PipeTransform {

  transform(items: any): boolean {
    return items.filter(log => {
        return (log && (!log.hidden));
      });
    }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/pipes/active-menu-items.pipe.ts